import React from 'react';
import { RIPPLE_ON_LIGHT } from '../../../../globalStyles';
import { scrollToId } from '../../../../utils';
import ReflectionButton from '../../../../components/reflectionButton/reflectionButton';
import { APP_STORE_URL } from '../../constants';
import { styles } from './styles';

export default function Hero(): JSX.Element {

  return (
    <section id="top" className="pc-gutter" style={styles.section}>
      <div style={styles.copy}>
        <p style={styles.eyebrow}>{APP_STORE_URL ? 'Free on iPhone' : 'Coming soon to iPhone'}</p>
        <h1 style={styles.headline}>Other players,<br />one swipe away.</h1>
        <p style={styles.subline}>
          <span style={styles.shared}>Same</span> games. <span style={styles.shared}>Same</span> hours.
        </p>
        <p style={styles.body}>
          PlayerCafe finds people who play the games you play, at the hours you play them. Swipe
          right to send a request, and start chatting once you connect.
        </p>
        <div style={styles.actions}>
          {APP_STORE_URL ? (
            <a href={APP_STORE_URL} style={styles.cta}>Download on the App Store</a>
          ) : (
            <ReflectionButton style={styles.cta} highlightColor={RIPPLE_ON_LIGHT} onClick={() => scrollToId('tour')}>
              See how it works
            </ReflectionButton>
          )}
          <span style={styles.ctaNote}>iPhone first. Android is on the way.</span>
        </div>
      </div>
    </section>
  );

}
